let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4iqE9")).then(() => parcelRequire('AmvTn'));